<template>
  <div class="lender-card-layout">
    <v-card>
      <div class="img-wrapper">
        <slot name="logo" />
      </div>

      <div class="score-wrapper">
        <slot name="score" />
      </div>

      <template v-if="$vuetify.breakpoint.mdAndDown">
        <div class="description-wrapper">
          <slot name="description" />
        </div>

        <div class="contact-wrapper">
          <slot name="contactButton" />
        </div>

        <div class="info-button-wrapper">
          <slot name="infoButton" />
        </div>

        <div class="disclaimer-wrapper">
          <slot name="disclaimer" />
        </div>
      </template>
    </v-card>

    <div
      v-if="$vuetify.breakpoint.lgAndUp"
      class="info-container">

      <div class="description-wrapper">
        <slot name="description" />
      </div>

      <div class="button-group">
        <div class="contact-wrapper">
          <slot name="contactButton" />
        </div>

        <div class="info-button-wrapper">
          <slot name="infoButton" />
        </div>
      </div>

      <div class="disclaimer-wrapper">
        <slot name="disclaimer" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LenderCardLayout',
}
</script>

<style lang="scss" scoped>
::v-deep {
  .img-wrapper {
    @include gridPos(1, 2, 1, 2);

    @include lg {
      @include unsetGrid;
    }
  }

  .score-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

    margin: 0 auto;
    height: 100%;

    @include gridPos(2, 3, 1, 2);
    & > * { margin-top: -15px; }

    h1 {
      color: #3A3A3A;
      font-family: "Sansation Regular", sans-serif;
      font-weight: normal;
    }

    p {
      color: #0A0A0A;
      font-family: "Avenir Book", sans-serif;
    }

    @include lg {
      @include unsetGrid;
      height: auto;

      & > * {
        margin-top: 0;
        margin-bottom: 7px;
        padding: 0;
      }
    }
  }

  .description-wrapper {
    color: $textDarkMuted;
    font-family: "Avenir Book", sans-serif;

    @include gridPos(3, 4, 1, 4);

    @include md {
      @include gridPos(3, 4, 1, 4);
    }

    @include lg {
      @include unsetGrid;
    }
  }

  .disclaimer-wrapper {
    color: $textDarkMuted;
    font-family: "Avenir Book", sans-serif;
    font-size: 14px;

    @include gridPos(5, 6, 1, 3);

    @include sm {
      @include gridPos(2, 3, 2, 3);
    }

    @include md {
      @include gridPos(2, 3, 2, 4);
    }

    @include lg {
      @include unsetGrid;
      width: 70%;
    }
  }

  .contact-wrapper {
    align-self: flex-end;

    @include gridPos(4, 5, 1, 3);

    @include sm {
      @include gridPos(1, 2, 2, 3);
    }

    @include md {
      @include gridPos(1, 2, 2, 3);
      margin-left: auto;
    }

    @include lg {
      @include unsetGrid;
      margin: 0;
    }

    .default-btn {
      padding: 0;
      width: 100%;

      @include md {
        height: 40px;
        width: 150px;

        font-size: 16px;
      }

      @include lg {
        height: 50px;
        width: 200px;
        margin: 0;

        font-size: 22px;
      }
    }
  }

  .info-button-wrapper {
    align-self: flex-end;
    width: 95%;
    margin: 0 auto;

    @include gridPos(6, 7, 1, 3);

    @include sm {
      @include gridPos(4, 5, 1, 3);
    }

    @include md {
      @include gridPos(1, 2, 3, 4);
      width: 100%;
      margin-left: auto;
      margin-right: auto;
    }

    @include lg {
      @include unsetGrid;
      margin: 0;
    }

    .default-btn {
      box-sizing: border-box;
      padding: 0;
      width: 100%;

      color: $primaryBlue !important;
      text-align: center;

      @include md {
        width: auto;
        margin: 0;
        font-size: 13px;
      }

      @include lg {
        font-size: 18px;
        margin-bottom: 0;
        margin-left: 20px;
      }
    }
  }
}

.lender-card-layout {
  width: 100%;
  margin-bottom: 64px;

  display: flex;
  flex-direction: row;

  .info-container {
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    padding-top: 10px;
    padding-left: 64px;

    .button-group {
      margin-top: 28px;
      margin-bottom: 20px;

      display: flex;
      justify-content: flex-start;
    }
  }
}

.v-card {
  flex-shrink: 0;
  display: grid;

  height: auto;
  width: 100%;
  padding: 5px 25px;

  background-color: white;
  box-shadow: 0px 7px 20px #00000029;
  border-top: 40px solid $primaryBlue;

  grid-template-columns: auto 1fr;
  grid-auto-rows: auto;
  grid-column-gap: 15px;
  grid-row-gap: 25px;

  padding-bottom: 25px;

  @include md {
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-rows: auto;

    padding-bottom: 40px;
  }

  @include lg {
    display: flex;
    flex-direction: column;
    align-items: center;

    height: 400px;
    width: 270px;
  }
}
</style>
